export function UnlinkedTable() {
  return (
    <svg
      width="214"
      height="116"
      viewBox="0 0 214 116"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_7797_47656)">
        <g clipPath="url(#clip1_7797_47656)">
          <mask id="path-3-inside-1_7797_47656" fill="white">
            <path d="M1.052 15.5122H213.515V30.8639H1.052V15.5122Z" />
          </mask>
          <mask id="path-5-inside-2_7797_47656" fill="white">
            <path d="M1.052 15.5122H19.8151V30.8639H1.052V15.5122Z" />
          </mask>
          <path
            d="M19.8151 15.5122H19.386V30.8639H19.8151H20.2442V15.5122H19.8151Z"
            fill="#B5B2AA"
            mask="url(#path-5-inside-2_7797_47656)"
          />
          <mask id="path-7-inside-3_7797_47656" fill="white">
            <path d="M19.8151 15.5122H62.4586V30.8639H19.8151V15.5122Z" />
          </mask>
          <path
            d="M62.4586 15.5122H62.0295V30.8639H62.4586H62.8877V15.5122H62.4586Z"
            fill="#B5B2AA"
            mask="url(#path-7-inside-3_7797_47656)"
          />
          <rect
            x="24.9322"
            y="20.6295"
            width="18.8022"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-10-inside-4_7797_47656" fill="white">
            <path d="M62.4586 15.5122H105.102V30.8639H62.4586V15.5122Z" />
          </mask>
          <path
            d="M105.102 15.5122H104.673V30.8639H105.102H105.531V15.5122H105.102Z"
            fill="#B5B2AA"
            mask="url(#path-10-inside-4_7797_47656)"
          />
          <rect
            x="67.5759"
            y="20.6295"
            width="22.5225"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-13-inside-5_7797_47656" fill="white">
            <path d="M105.102 15.5122H147.745V30.8639H105.102V15.5122Z" />
          </mask>
          <path
            d="M147.745 15.5122H147.316V30.8639H147.745H148.175V15.5122H147.745Z"
            fill="#B5B2AA"
            mask="url(#path-13-inside-5_7797_47656)"
          />
          <rect
            x="110.219"
            y="20.6295"
            width="22.5225"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-16-inside-6_7797_47656" fill="white">
            <path d="M147.745 15.5122H190.389V30.8639H147.745V15.5122Z" />
          </mask>
          <path
            d="M190.389 15.5122H189.96V30.8639H190.389H190.818V15.5122H190.389Z"
            fill="#B5B2AA"
            mask="url(#path-16-inside-6_7797_47656)"
          />
          <rect
            x="200.469"
            y="20.5416"
            width="22.5225"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
        </g>
        <path
          d="M1.052 15.5122V15.9414H213.515V15.5122V15.0831H1.052V15.5122ZM213.515 30.8639V30.4348H1.052V30.8639V31.293H213.515V30.8639Z"
          fill="#B5B2AA"
          mask="url(#path-3-inside-1_7797_47656)"
        />
        <g clipPath="url(#clip2_7797_47656)">
          <mask id="path-19-inside-7_7797_47656" fill="white">
            <path d="M1.05225 30.8639H213.515V46.2155H1.05225V30.8639Z" />
          </mask>
          <mask id="path-21-inside-8_7797_47656" fill="white">
            <path d="M1.05225 30.8639H19.8154V46.2155H1.05225V30.8639Z" />
          </mask>
          <path
            d="M19.8154 30.8639H19.3863V46.2155H19.8154H20.2445V30.8639H19.8154Z"
            fill="#B5B2AA"
            mask="url(#path-21-inside-8_7797_47656)"
          />
          <path
            d="M7.23639 41.7377H13.6329V35.3412H7.23639V41.7377ZM7.94711 36.0519H12.9222V41.027H7.94711V36.0519Z"
            fill="#B5B2AA"
          />
          <mask id="path-24-inside-9_7797_47656" fill="white">
            <path d="M19.8154 30.8638H62.4588V46.2155H19.8154V30.8638Z" />
          </mask>
          <path
            d="M62.4588 30.8638H62.0297V46.2155H62.4588H62.8879V30.8638H62.4588Z"
            fill="#B5B2AA"
            mask="url(#path-24-inside-9_7797_47656)"
          />
          <rect
            x="24.9324"
            y="35.9808"
            width="30.2314"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-27-inside-10_7797_47656" fill="white">
            <path d="M62.4588 30.8639H105.102V46.2155H62.4588V30.8639Z" />
          </mask>
          <path
            d="M105.102 30.8639H104.673V46.2155H105.102H105.531V30.8639H105.102Z"
            fill="#B5B2AA"
            mask="url(#path-27-inside-10_7797_47656)"
          />
          <rect
            x="67.5762"
            y="35.9809"
            width="17.1315"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-30-inside-11_7797_47656" fill="white">
            <path d="M105.102 30.8639H147.746V46.2155H105.102V30.8639Z" />
          </mask>
          <path
            d="M147.746 30.8639H147.317V46.2155H147.746H148.175V30.8639H147.746Z"
            fill="#B5B2AA"
            mask="url(#path-30-inside-11_7797_47656)"
          />
          <rect
            x="110.219"
            y="35.9809"
            width="17.1315"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-33-inside-12_7797_47656" fill="white">
            <path d="M147.746 30.8639H190.389V46.2155H147.746V30.8639Z" />
          </mask>
          <path
            d="M190.389 30.8639H189.96V46.2155H190.389H190.818V30.8639H190.389Z"
            fill="#B5B2AA"
            mask="url(#path-33-inside-12_7797_47656)"
          />
          <rect
            x="152.863"
            y="35.9809"
            width="17.1315"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-36-inside-13_7797_47656" fill="white">
            <path d="M190.389 30.8639H233.033V46.2155H190.389V30.8639Z" />
          </mask>
          <path
            d="M233.033 30.8639H232.604V46.2155H233.033H233.462V30.8639H233.033Z"
            fill="#B5B2AA"
            mask="url(#path-36-inside-13_7797_47656)"
          />
          <rect
            x="195.507"
            y="35.9809"
            width="17.1315"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
        </g>
        <path
          d="M213.515 46.2155V45.7864H1.05225V46.2155V46.6446H213.515V46.2155Z"
          fill="#B5B2AA"
          mask="url(#path-19-inside-7_7797_47656)"
        />
        <g clipPath="url(#clip3_7797_47656)">
          <mask id="path-39-inside-14_7797_47656" fill="white">
            <path d="M1.05225 46.2155H213.515V61.5672H1.05225V46.2155Z" />
          </mask>
          <mask id="path-41-inside-15_7797_47656" fill="white">
            <path d="M1.05225 46.2155H19.8154V61.5672H1.05225V46.2155Z" />
          </mask>
          <path
            d="M19.8154 46.2155H19.3863V61.5672H19.8154H20.2445V46.2155H19.8154Z"
            fill="#B5B2AA"
            mask="url(#path-41-inside-15_7797_47656)"
          />
          <path
            d="M7.23639 57.0893H13.6329V50.6928H7.23639V57.0893ZM7.94711 51.4035H12.9222V56.3786H7.94711V51.4035Z"
            fill="#B5B2AA"
          />
          <mask id="path-44-inside-16_7797_47656" fill="white">
            <path d="M19.8154 46.2156H62.4588V61.5672H19.8154V46.2156Z" />
          </mask>
          <path
            d="M62.4588 46.2156H62.0297V61.5672H62.4588H62.8879V46.2156H62.4588Z"
            fill="#B5B2AA"
            mask="url(#path-44-inside-16_7797_47656)"
          />
          <rect
            x="24.9324"
            y="51.3326"
            width="25.9187"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-47-inside-17_7797_47656" fill="white">
            <path d="M62.4588 46.2155H105.102V61.5672H62.4588V46.2155Z" />
          </mask>
          <path
            d="M105.102 46.2155H104.673V61.5672H105.102H105.531V46.2155H105.102Z"
            fill="#B5B2AA"
            mask="url(#path-47-inside-17_7797_47656)"
          />
          <rect
            x="67.5762"
            y="51.3326"
            width="27.0511"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-50-inside-18_7797_47656" fill="white">
            <path d="M105.102 46.2155H147.746V61.5672H105.102V46.2155Z" />
          </mask>
          <path
            d="M147.746 46.2155H147.317V61.5672H147.746H148.175V46.2155H147.746Z"
            fill="#B5B2AA"
            mask="url(#path-50-inside-18_7797_47656)"
          />
          <rect
            x="110.219"
            y="51.3326"
            width="27.0511"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-53-inside-19_7797_47656" fill="white">
            <path d="M147.746 46.2155H190.389V61.5672H147.746V46.2155Z" />
          </mask>
          <path
            d="M190.389 46.2155H189.96V61.5672H190.389H190.818V46.2155H190.389Z"
            fill="#B5B2AA"
            mask="url(#path-53-inside-19_7797_47656)"
          />
          <rect
            x="152.863"
            y="51.3326"
            width="27.0511"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-56-inside-20_7797_47656" fill="white">
            <path d="M190.389 46.2155H233.033V61.5672H190.389V46.2155Z" />
          </mask>
          <path
            d="M233.033 46.2155H232.604V61.5672H233.033H233.462V46.2155H233.033Z"
            fill="#B5B2AA"
            mask="url(#path-56-inside-20_7797_47656)"
          />
          <rect
            x="195.507"
            y="51.3326"
            width="27.0511"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
        </g>
        <path
          d="M213.515 61.5672V61.138H1.05225V61.5672V61.9963H213.515V61.5672Z"
          fill="#B5B2AA"
          mask="url(#path-39-inside-14_7797_47656)"
        />
        <g clipPath="url(#clip4_7797_47656)">
          <mask id="path-59-inside-21_7797_47656" fill="white">
            <path d="M1.05225 61.5672H213.515V76.9188H1.05225V61.5672Z" />
          </mask>
          <mask id="path-61-inside-22_7797_47656" fill="white">
            <path d="M1.05225 61.5672H19.8154V76.9188H1.05225V61.5672Z" />
          </mask>
          <path
            d="M19.8154 61.5672H19.3863V76.9188H19.8154H20.2445V61.5672H19.8154Z"
            fill="#B5B2AA"
            mask="url(#path-61-inside-22_7797_47656)"
          />
          <path
            d="M7.23639 72.4411H13.6329V66.0445H7.23639V72.4411ZM7.94711 66.7553H12.9222V71.7303H7.94711V66.7553Z"
            fill="#B5B2AA"
          />
          <mask id="path-64-inside-23_7797_47656" fill="white">
            <path d="M19.8154 61.5672H62.4588V76.9189H19.8154V61.5672Z" />
          </mask>
          <path
            d="M62.4588 61.5672H62.0297V76.9189H62.4588H62.8879V61.5672H62.4588Z"
            fill="#B5B2AA"
            mask="url(#path-64-inside-23_7797_47656)"
          />
          <rect
            x="24.9324"
            y="66.6843"
            width="28.9375"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-67-inside-24_7797_47656" fill="white">
            <path d="M62.4588 61.5672H105.102V76.9188H62.4588V61.5672Z" />
          </mask>
          <path
            d="M105.102 61.5672H104.673V76.9188H105.102H105.531V61.5672H105.102Z"
            fill="#B5B2AA"
            mask="url(#path-67-inside-24_7797_47656)"
          />
          <rect
            x="67.5762"
            y="66.6842"
            width="18.6407"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-70-inside-25_7797_47656" fill="white">
            <path d="M105.102 61.5672H147.746V76.9188H105.102V61.5672Z" />
          </mask>
          <path
            d="M147.746 61.5672H147.317V76.9188H147.746H148.175V61.5672H147.746Z"
            fill="#B5B2AA"
            mask="url(#path-70-inside-25_7797_47656)"
          />
          <rect
            x="110.219"
            y="66.6842"
            width="18.6407"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-73-inside-26_7797_47656" fill="white">
            <path d="M147.746 61.5672H190.389V76.9188H147.746V61.5672Z" />
          </mask>
          <path
            d="M190.389 61.5672H189.96V76.9188H190.389H190.818V61.5672H190.389Z"
            fill="#B5B2AA"
            mask="url(#path-73-inside-26_7797_47656)"
          />
          <rect
            x="152.863"
            y="66.6842"
            width="18.6407"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <rect
            x="195.506"
            y="66.6842"
            width="23.8803"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
        </g>
        <path
          d="M213.515 76.9188V76.4897H1.05225V76.9188V77.3479H213.515V76.9188Z"
          fill="#B5B2AA"
          mask="url(#path-59-inside-21_7797_47656)"
        />
        <g clipPath="url(#clip5_7797_47656)">
          <mask id="path-77-inside-27_7797_47656" fill="white">
            <path d="M1.05225 76.9188H213.515V92.2704H1.05225V76.9188Z" />
          </mask>
          <mask id="path-79-inside-28_7797_47656" fill="white">
            <path d="M1.05225 76.9188H19.8154V92.2704H1.05225V76.9188Z" />
          </mask>
          <path
            d="M19.8154 76.9188H19.3863V92.2704H19.8154H20.2445V76.9188H19.8154Z"
            fill="#B5B2AA"
            mask="url(#path-79-inside-28_7797_47656)"
          />
          <path
            d="M7.23639 87.7927H13.6329V81.3962H7.23639V87.7927ZM7.94711 82.1069H12.9222V87.082H7.94711V82.1069Z"
            fill="#B5B2AA"
          />
          <mask id="path-82-inside-29_7797_47656" fill="white">
            <path d="M19.8154 76.9188H62.4588V92.2704H19.8154V76.9188Z" />
          </mask>
          <path
            d="M62.4588 76.9188H62.0297V92.2704H62.4588H62.8879V76.9188H62.4588Z"
            fill="#B5B2AA"
            mask="url(#path-82-inside-29_7797_47656)"
          />
          <rect
            x="24.9324"
            y="82.0359"
            width="21.8213"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-85-inside-30_7797_47656" fill="white">
            <path d="M62.4588 76.9188H105.102V92.2704H62.4588V76.9188Z" />
          </mask>
          <path
            d="M105.102 76.9188H104.673V92.2704H105.102H105.531V76.9188H105.102Z"
            fill="#B5B2AA"
            mask="url(#path-85-inside-30_7797_47656)"
          />
          <rect
            x="67.5762"
            y="82.0359"
            width="19.5033"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-88-inside-31_7797_47656" fill="white">
            <path d="M105.102 76.9188H147.746V92.2704H105.102V76.9188Z" />
          </mask>
          <path
            d="M147.746 76.9188H147.317V92.2704H147.746H148.175V76.9188H147.746Z"
            fill="#B5B2AA"
            mask="url(#path-88-inside-31_7797_47656)"
          />
          <rect
            x="110.219"
            y="82.0359"
            width="19.5033"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-91-inside-32_7797_47656" fill="white">
            <path d="M147.746 76.9188H190.389V92.2704H147.746V76.9188Z" />
          </mask>
          <path
            d="M190.389 76.9188H189.96V92.2704H190.389H190.818V76.9188H190.389Z"
            fill="#B5B2AA"
            mask="url(#path-91-inside-32_7797_47656)"
          />
          <rect
            x="152.863"
            y="82.0359"
            width="19.5033"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <rect
            x="195.507"
            y="82.0359"
            width="23.8803"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
        </g>
        <path
          d="M213.515 92.2704V91.8413H1.05225V92.2704V92.6995H213.515V92.2704Z"
          fill="#B5B2AA"
          mask="url(#path-77-inside-27_7797_47656)"
        />
        <g clipPath="url(#clip6_7797_47656)">
          <mask id="path-95-inside-33_7797_47656" fill="white">
            <path d="M1.05225 92.2704H213.515V107.622H1.05225V92.2704Z" />
          </mask>
          <mask id="path-97-inside-34_7797_47656" fill="white">
            <path d="M1.05225 92.2704H19.8154V107.622H1.05225V92.2704Z" />
          </mask>
          <path
            d="M19.8154 92.2704H19.3863V107.622H19.8154H20.2445V92.2704H19.8154Z"
            fill="#B5B2AA"
            mask="url(#path-97-inside-34_7797_47656)"
          />
          <path
            d="M7.23639 103.144H13.6329V96.7479H7.23639V103.144ZM7.94711 97.4586H12.9222V102.434H7.94711V97.4586Z"
            fill="#B5B2AA"
          />
          <mask id="path-100-inside-35_7797_47656" fill="white">
            <path d="M19.8154 92.2706H62.4588V107.622H19.8154V92.2706Z" />
          </mask>
          <path
            d="M62.4588 92.2706H62.0297V107.622H62.4588H62.8879V92.2706H62.4588Z"
            fill="#B5B2AA"
            mask="url(#path-100-inside-35_7797_47656)"
          />
          <rect
            x="24.9324"
            y="97.3877"
            width="30.8784"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-103-inside-36_7797_47656" fill="white">
            <path d="M62.4588 92.2704H105.102V107.622H62.4588V92.2704Z" />
          </mask>
          <path
            d="M105.102 92.2704H104.673V107.622H105.102H105.531V92.2704H105.102Z"
            fill="#B5B2AA"
            mask="url(#path-103-inside-36_7797_47656)"
          />
          <rect
            x="67.5762"
            y="97.3876"
            width="22.0912"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-106-inside-37_7797_47656" fill="white">
            <path d="M105.102 92.2704H147.746V107.622H105.102V92.2704Z" />
          </mask>
          <path
            d="M147.746 92.2704H147.317V107.622H147.746H148.175V92.2704H147.746Z"
            fill="#B5B2AA"
            mask="url(#path-106-inside-37_7797_47656)"
          />
          <rect
            x="110.219"
            y="97.3876"
            width="22.0912"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <mask id="path-109-inside-38_7797_47656" fill="white">
            <path d="M147.746 92.2704H190.389V107.622H147.746V92.2704Z" />
          </mask>
          <path
            d="M190.389 92.2704H189.96V107.622H190.389H190.818V92.2704H190.389Z"
            fill="#B5B2AA"
            mask="url(#path-109-inside-38_7797_47656)"
          />
          <rect
            x="152.863"
            y="97.3876"
            width="22.0912"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
          <rect
            x="195.507"
            y="97.3876"
            width="23.8803"
            height="5.11721"
            rx="2.55861"
            fill="#ECE9DF"
          />
        </g>
        <path
          d="M213.515 107.622V107.193H1.05225V107.622V108.051H213.515V107.622Z"
          fill="#B5B2AA"
          mask="url(#path-95-inside-33_7797_47656)"
        />
        <path
          d="M8.03247 6.52875H12.2686V7.1339H8.03247V6.52875Z"
          fill="#B5B2AA"
        />
        <path
          d="M8.03247 7.73906H10.68V8.34421H8.03247V7.73906Z"
          fill="#B5B2AA"
        />
        <path
          d="M10.68 10.1597H8.03247V10.7648H10.68V10.1597Z"
          fill="#B5B2AA"
        />
        <path
          d="M8.03247 8.94937H12.2686V9.55452H8.03247V8.94937Z"
          fill="#B5B2AA"
        />
      </g>
      <rect
        x="0.408555"
        y="0.730301"
        width="213.183"
        height="114.539"
        rx="5.61198"
        stroke="#B5B2AA"
        strokeWidth="0.72"
      />
      <defs>
        <clipPath id="clip0_7797_47656">
          <rect
            x="0.768555"
            y="1.0903"
            width="212.463"
            height="113.819"
            rx="5.25198"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip1_7797_47656">
          <path
            d="M1.052 15.5122H213.515V30.8639H1.052V15.5122Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip2_7797_47656">
          <path
            d="M1.05225 30.8639H213.515V46.2155H1.05225V30.8639Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip3_7797_47656">
          <path
            d="M1.05225 46.2155H213.515V61.5672H1.05225V46.2155Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip4_7797_47656">
          <path
            d="M1.05225 61.5672H213.515V76.9188H1.05225V61.5672Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip5_7797_47656">
          <path
            d="M1.05225 76.9188H213.515V92.2704H1.05225V76.9188Z"
            fill="white"
          />
        </clipPath>
        <clipPath id="clip6_7797_47656">
          <path
            d="M1.05225 92.2704H213.515V107.622H1.05225V92.2704Z"
            fill="white"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
